import { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { markCheckoutStarted } from '../hooks/useExitIntent';
import { CheckCircle2, AlertTriangle, Plus, Minus } from 'lucide-react';
import { PRODUCTS } from './MetaPixel';
export const ProductTomos = () => {
  const [openTomo, setOpenTomo] = useState<number | null>(null);
  const tomos = [{
    emoji: '📙',
    title: 'Tomo 1 — Fuerza Base & Estabilidad',
    sessions: '61 sesiones',
    months: 'Meses 1 y 2',
    desc: 'Para construir cimientos sólidos y fuerza estructural en tus alumnos desde el primer día.',
    color: 'bg-[#FF6B00]',
    borderColor: 'border-t-[#FF6B00]'
  }, {
    emoji: '📘',
    title: 'Tomo 2 — Potencia & Transferencia Funcional',
    sessions: '61 sesiones',
    months: 'Meses 3 y 4',
    desc: 'Para desarrollar velocidad, explosividad y transferencia directa a gestos deportivos.',
    color: 'bg-[#3B82F6]',
    borderColor: 'border-t-[#3B82F6]'
  }, {
    emoji: '📕',
    title: 'Tomo 3 — Resistencia Metabólica & Fat Loss',
    sessions: '61 sesiones',
    months: 'Meses 5 y 6',
    desc: 'Para quemar grasa y llevar el acondicionamiento metabólico de tu grupo al límite.',
    color: 'bg-[#EF4444]',
    borderColor: 'border-t-[#EF4444]'
  }, {
    emoji: '📓',
    title: 'Tomo 4 — Hipertrofia Funcional',
    sessions: '61 sesiones',
    months: 'Meses 7 y 8',
    desc: 'Para ganar masa muscular de forma funcional con protocolos de hipertrofia adaptados.',
    color: 'bg-[#8B5CF6]',
    borderColor: 'border-t-[#8B5CF6]'
  }, {
    emoji: '📗',
    title: 'Tomo 5 — Agilidad & Rendimiento Atlético',
    sessions: '61 sesiones',
    months: 'Meses 9 y 10',
    desc: 'Para mejorar la coordinación, agilidad y capacidad atlética general en cualquier nivel.',
    color: 'bg-[#10B981]',
    borderColor: 'border-t-[#10B981]'
  }, {
    emoji: '📔',
    title: 'Tomo 6 — Especialización & Desafíos Finales',
    sessions: '60 sesiones',
    months: 'Meses 11 y 12',
    desc: 'Para poner a prueba todo lo aprendido en el año con desafíos y benchmarks competitivos.',
    color: 'bg-[#F59E0B]',
    borderColor: 'border-t-[#F59E0B]'
  }];
  const features = ['Objetivo del día claro y visible', 'Materiales con íconos visuales', 'Warm-up listo para dictar', 'Parte principal con series, reps y tiempos', '3 versiones: Principiante, Intermedio, Avanzado', 'Cool down específico de la sesión', 'Tip del Coach al final de cada hoja', 'Una sesión por página — sin hojas complicadas'];
  const featureChips = ['✅ Gym + Box + Funcional', '✅ Programa anual listo', '✅ Versiones A/B/C por nivel', '✅ Warm-ups y cool downs', '✅ 365 sesiones listas', '✅ Equipamiento básico'];
  return <Section className="bg-bg-base !pt-3 md:!pt-8" data-id="element-18" data-mp="bjr6yw8yenod">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-19" data-mp="gjvn2l5y9ge2">
        {/* Yellow trust pill */}
        <div className="flex justify-center mb-4 md:mb-5" data-id="element-20" data-mp="ligepw74yrqw">
          <span className="inline-flex items-center gap-1.5 font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] px-3 py-1 md:px-3.5 md:py-1.5 rounded-full" style={{
          background: 'linear-gradient(135deg, #D4A41C 0%, #F0BE2A 50%, #D4A41C 100%)',
          color: '#1A1303',
          boxShadow: '0 0 20px rgba(212,164,28,0.4)'
        }} data-id="element-21" data-mp="liq3jggg2sv0">
            🏆 Sistema n°1 para profesores de Funcional
          </span>
        </div>

        <h2 className="font-display font-extrabold uppercase text-txt-primary mb-3 md:mb-4 md:text-[44px] text-[32px]" data-id="element-22" data-mp="1edeh2ceuu87m">
          🏆 MEGAPACK FUNCIONAL <span className="text-brandOrange" data-id="element-23" data-mp="19ebm5ksl9idd">365™</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-24" data-mp="14ma1bahcujbq">
          6 Tomos + 5 Bonos — 365 sesiones listas · Un año completo · Todo
          resuelto.
        </p>
      </FadeIn>

      {/* Colored book strip with emoji */}
      <FadeIn delay={0.2} className="mb-5 md:mb-8" data-id="element-25" data-mp="1scnu537rkm7d">
        <div className="flex justify-center gap-2 md:gap-4 px-2 md:px-0" data-id="element-26" data-mp="1sb333nknrle9">
          {tomos.map((tomo, i) => <div key={i} className={`${tomo.color} w-[44px] md:w-28 h-[60px] md:h-36 rounded-md md:rounded-lg shadow-lg flex flex-col items-center justify-center gap-0.5 md:gap-2 p-1 md:p-3 text-center text-white relative overflow-hidden transform hover:-translate-y-1 transition-transform border border-white/20`} data-id="element-27" data-mp="1ct1qxp2uxhg9" data-mpi={i}>
              <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent h-1/3" data-id="element-28" data-mp="17xmduzcobpkw"></div>
              <span className="font-sans font-bold uppercase tracking-[1px] text-[8px] md:text-[10px] leading-tight drop-shadow-md relative z-10" data-id="element-29" data-mp="1vn77qdad878y">
                Tomo {i + 1}
              </span>
            </div>)}
        </div>
        <div className="text-center mt-3 md:mt-4" data-id="element-30" data-mp="1qu5t86e2m9pw">
          <span className="inline-block bg-brandOrange text-white font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full" data-id="element-31" data-mp="1qsuljvhi8hti">
            6 TOMOS COMPLETOS
          </span>
        </div>
      </FadeIn>

      <FadeIn delay={0.3} className="mb-8 md:mb-12" data-id="element-32" data-mp="7v7yfq7ylk25">
        <div className="flex flex-wrap justify-center gap-x-1 gap-y-1 md:gap-x-1.5 md:gap-y-1.5 max-w-3xl mx-auto" data-id="element-33" data-mp="7tn0rrqcll02">
          {featureChips.map((chip, i) => <span key={i} className="bg-brandOrange/10 text-brandOrange border border-brandOrange/30 px-1.5 py-0.5 md:px-2 md:py-1 rounded-full font-sans font-bold uppercase tracking-[0.5px] md:tracking-[1px] text-[8.5px] md:text-[10px] whitespace-nowrap" data-id="element-34" data-mp="hlsq0tp7tobk" data-mpi={i}>
              {chip}
            </span>)}
        </div>
      </FadeIn>

      <FadeIn delay={0.35} className="text-center mb-5 md:mb-7" data-id="element-35" data-mp="3g4ge9wz752qt">
        <div className="inline-flex items-center gap-2 bg-bg-card border border-brandOrange/30 rounded-full px-4 py-1.5 md:px-5 md:py-2" data-id="element-36" data-mp="3v0yujwm5mcws">
          <span className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] md:text-[13px] text-brandOrange" data-id="element-37" data-mp="3pzrn5ynxbfqn">
            📦 Lo que recibís:
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5 mb-12 md:mb-16" data-id="element-38" data-mp="15alpv18ykgbg">
        {tomos.map((tomo, i) => {
        const isOpen = openTomo === i;
        return <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-39" data-mp="1hcdbzzekvyd0" data-mpi={i}>
              <button type="button" onClick={() => setOpenTomo(isOpen ? null : i)} className={`w-full text-left bg-bg-card rounded-[16px] md:rounded-[20px] p-4 md:p-6 border-x border-b transition-all border-t-[3px] ${isOpen ? 'border-brandOrange shadow-[0_0_40px_rgba(255,107,0,0.2)]' : `border-x-line border-b-line ${tomo.borderColor}`}`} aria-expanded={isOpen} data-id="element-40" data-mp="1mchq5is0kh02">
                <div className="flex items-start justify-between gap-3" data-id="element-41" data-mp="yn6mntja48i8">
                  <div className="flex items-start gap-2.5 md:gap-3 min-w-0 flex-1" data-id="element-42" data-mp="13kyopgdn1b05">
                    <div className="text-2xl md:text-4xl shrink-0" data-id="element-43" data-mp="18cyj6taxvbpc">
                      {tomo.emoji}
                    </div>
                    <div className="min-w-0" data-id="element-44" data-mp="awt3ksio9jzs">
                      <h3 className="font-sans font-bold text-[15px] md:text-xl text-txt-primary leading-snug mb-1.5 md:mb-2" data-id="element-45" data-mp="fw5t5l0xh562">
                        {tomo.title}
                      </h3>
                      <div className="flex flex-wrap gap-1.5" data-id="element-46" data-mp="2p53r500glp48">
                        <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-brandOrange bg-brandOrange/10 px-2 py-0.5 rounded" data-id="element-47" data-mp="2p5vddk862ahu">
                          {tomo.sessions}
                        </span>
                        <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-txt-muted bg-white/5 px-2 py-0.5 rounded" data-id="element-48" data-mp="2a7kw5fx6ufoc">
                          {tomo.months}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className={`w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center shrink-0 transition-all ${isOpen ? 'bg-brandOrange text-white rotate-180' : 'bg-bg-highlight text-txt-primary hover:bg-line'}`} data-id="element-49" data-mp="1wgy8cisyua71">
                    {isOpen ? <Minus size={14} data-id="element-50" data-mp="1mis62038z21n" /> : <Plus size={14} data-id="element-51" data-mp="1mkbmbqowld3f" />}
                  </div>
                </div>
                <div className={`grid transition-all duration-300 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100 mt-3 md:mt-4' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-52" data-mp="3bd7kmrnukyea">
                  <div className="overflow-hidden" data-id="element-53" data-mp="31f1jic9v7wah">
                    <p className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body" data-id="element-54" data-mp="31gmf857x1l9x">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
              </button>
            </FadeIn>;
      })}
      </div>

      <FadeIn delay={0.4} data-id="element-55" data-mp="2wfyozlrih8gr">
        <div className="bg-bg-card rounded-[20px] p-5 md:p-10 border border-line max-w-4xl mx-auto" data-id="element-56" data-mp="2wh9v3s8fisb1">
          <h3 className="font-sans font-bold text-lg md:text-xl text-center text-txt-primary leading-snug mb-5 md:mb-8" data-id="element-57" data-mp="2ilnyozzv968l">
            Cada sesión incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2.5 md:gap-4" data-id="element-58" data-mp="28qvxlm72s192">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-2 md:gap-3" data-id="element-59" data-mp="2dnw2vuw3ozz4" data-mpi={i}>
                <CheckCircle2 className="text-success shrink-0 mt-0.5 w-4 h-4 md:w-5 md:h-5" data-id="element-60" data-mp="1u3ni496qh9ra" />
                <span className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body" data-id="element-61" data-mp="1q2c0oqy0juu6">
                  {feature}
                </span>
              </div>)}
          </div>

          <div className="mt-6 md:mt-8 text-center" data-id="element-62" data-mp="1z1pbpo1scrh0">
            <p className="font-sans font-bold text-base md:text-xl text-brandOrange leading-snug" data-id="element-63" data-mp="1z41oznwlmdnq">
              Abrís el TOMO, Elegís la sesión y dictás. Así de simple. 365
              clases de alto rendimiento. Listas desde hoy.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};
export const Bonuses = () => {
  const bonuses = [{
    num: '01',
    icon: '🔧',
    title: 'Kit de Adaptaciones Rápidas',
    desc: 'Versión A, B y C para cada ejercicio. La misma clase para grupos mixtos.',
    value: '$12.000',
    image: 'https://cdn.magicpatterns.com/uploads/uiThw6MmkhzjeK1izuU75Y/BONO_1.webp'
  }, {
    num: '02',
    icon: '🔥',
    title: 'Banco de 20 Warm-Ups Listos',
    desc: 'Calentamientos específicos por tipo de sesión. Express y completos.',
    value: '$10.000',
    image: 'https://cdn.magicpatterns.com/uploads/mznfrhWEab51iuJMDAVGxh/BONO_2.webp'
  }, {
    num: '03',
    icon: '🧊',
    title: 'Banco de 20 Cool Downs y Cierres',
    desc: 'Terminá cada clase con profesionalismo. Scripts de cierre incluidos.',
    value: '$10.000',
    image: 'https://cdn.magicpatterns.com/uploads/8BmieAD5enaNdNDJrabV5c/BONO_3.webp'
  }, {
    num: '04',
    icon: '🎤',
    title: '50 Frases y Scripts de Coaching',
    desc: 'Las palabras exactas para motivar, corregir y liderar tu clase.',
    value: '$9.000',
    image: 'https://cdn.magicpatterns.com/uploads/vtM6h2S7SiZGPcTo7Jag9s/BONO_4.webp'
  }, {
    num: '05',
    icon: '📊',
    title: 'Planilla Maestra del Sistema',
    desc: 'Vista anual, mensual, semanal y diaria. Sin improvisar.',
    value: '$9.000',
    image: 'https://cdn.magicpatterns.com/uploads/eBSsoCAHqPctuYrAtz3Yxa/BONO_5.webp'
  }];
  return <Section className="bg-bg-alt" data-id="element-64" data-mp="3w2z4jlgboxik">
      <FadeIn className="text-center mb-8 md:mb-14" data-id="element-65" data-mp="4xpnijab3tl3">
        <h2 className="font-display font-extrabold uppercase md:text-[44px] text-txt-primary mb-2 md:mb-4 text-[34px]" data-id="element-66" data-mp="4w4qmn0iryk2">
          + 5 BONOS <span className="text-brandOrange" data-id="element-67" data-mp="drcezx7heaoh">ESTRATÉGICOS</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-68" data-mp="dsnevlxt2yab">
          Materiales exclusivos — sin costo extra
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-12" data-id="element-69" data-mp="nr3aa13v8tpm">
        {bonuses.map((bono, i) => <FadeIn key={bono.num} delay={Math.min(i * 0.05, 0.2)} data-id="element-70" data-mp="sm8w6zx9q8dp" data-mpi={i}>
            <article className="bg-bg-card rounded-[16px] border border-line border-l-[3px] border-l-brandOrange h-full overflow-hidden flex gap-3 p-3 md:gap-4 md:p-4" data-id="element-71" data-mp="wp5704gkh073">
              <img src={bono.image} alt={`Portada del bono ${bono.num}: ${bono.title}`} loading="lazy" decoding="async" width={128} height={171} className="w-24 self-start aspect-[3/4] shrink-0 rounded-[10px] object-cover border border-white/10 md:w-32" data-id="element-72" data-mp="2yg9x2w2upspb" />
              <div className="min-w-0 flex flex-1 flex-col" data-id="element-73" data-mp="pt9qkveje2z">
                <div className="flex items-center justify-between gap-2 mb-1.5" data-id="element-74" data-mp="eo118d9o5n6r">
                  <div className="flex items-center gap-1.5" data-id="element-75" data-mp="alef8szoiwhh">
                    <span className="text-lg md:text-xl" data-id="element-76" data-mp="olfjmif5km1p">🎁</span>
                    <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandOrange" data-id="element-77" data-mp="ojukefhw8exi">
                      BONO {bono.num}
                    </span>
                  </div>
                  <span className="text-lg md:text-xl" aria-hidden="true" data-id="element-78" data-mp="ydbfrnxoi23a">{bono.icon}</span>
                </div>
                <h3 className="font-sans font-bold text-[13.5px] md:text-[15px] text-txt-primary leading-snug mb-1 md:mb-1.5" data-id="element-79" data-mp="tei5e4dour7c">
                  {bono.title}
                </h3>
                <p className="font-sans text-[12px] md:text-[13.5px] leading-[1.45] md:leading-[1.55] text-txt-body mb-2.5 md:mb-3" data-id="element-80" data-mp="12en7bz044xe4">
                  {bono.desc}
                </p>
                <div className="mt-auto pt-2 md:pt-2.5 border-t border-line flex items-center justify-between gap-2" data-id="element-81" data-mp="1qx6vpdp6m1vq">
                  <span className="font-sans font-normal text-[12px] md:text-[14px] line-through text-danger" data-id="element-82" data-mp="1d00gft3o2lb9">
                    {bono.value}
                  </span>
                  <span className="bg-success text-white font-sans font-bold uppercase tracking-[1px] text-[8.5px] md:text-[10px] px-2 py-0.5 rounded-full" data-id="element-83" data-mp="137ck0zglmjd2">
                    GRATIS
                  </span>
                </div>
              </div>
            </article>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} className="text-center bg-bg-card p-5 md:p-8 rounded-[20px] border border-line max-w-2xl mx-auto" data-id="element-84" data-mp="y9t8467diioa">
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body mb-2" data-id="element-85" data-mp="kbd1ef9igs65">
          Valor total de los 5 Bonos
        </p>
        <p className="font-sans font-normal text-[16px] md:text-[18px] line-through text-danger mb-2" data-id="element-86" data-mp="h86tj02by2zk">
          $50.000
        </p>
        <p className="font-display font-black text-[24px] md:text-[44px] leading-[1.1] mb-1 md:mb-2 text-[#22C55E]" data-id="element-87" data-mp="c9vod2mzcgno">
          🎁 GRATIS — CON TU MEGAPACK
        </p>
        <p className="font-sans text-[13px] md:text-[16px] leading-[1.5] text-txt-muted" data-id="element-88" data-mp="3gsd90zt4fw7">
          Incluidos en tu MEGAPACK, sin costo extra.
        </p>
      </FadeIn>
    </Section>;
};
export const UrgencyCounter = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="bg-bg-base px-4 md:px-6 py-10 md:py-20 overflow-hidden" data-id="element-89" data-mp="3knuh7vennlwy">
      <div className="max-w-[1100px] mx-auto" data-id="element-90" data-mp="3gmshldgtt7ug">
        <FadeIn className="max-w-3xl mx-auto" data-id="element-91" data-mp="3go3rlv0v7bu0">
          <div className="rounded-[20px] border-2 border-brandOrange p-6 md:p-10 text-center space-y-6 bg-bg-card max-w-lg mx-auto shadow-[0_0_50px_rgba(255,107,0,0.2),inset_0_0_30px_rgba(255,107,0,0.03)]" data-id="element-92" data-mp="1ix0tgkuijydv">
            <h3 className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-brandOrange" data-id="element-93" data-mp="2wtajen9bwx9i">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h3>
            <div className="flex justify-center gap-2.5 md:gap-4 text-white animate-glow-button" data-id="element-94" data-mp="31q12zkkceazo">
              <div className="bg-bg-card border-2 border-brandOrange rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center shadow-[0_0_25px_rgba(255,107,0,0.4)]" data-id="element-95" data-mp="36kygb3onn6id">
                <div className="font-display font-black text-[40px] md:text-[52px] text-brandOrange leading-none" data-id="element-96" data-mp="2dwj2gkh9eu8m">
                  {hours.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandOrange mt-1" data-id="element-97" data-mp="2mx7kdq9rxeqs">
                  hs
                </div>
              </div>
              <div className="font-display font-black text-[40px] md:text-[52px] py-2 text-brandOrange flex items-center" data-id="element-98" data-mp="26qbi6v4g39x">
                :
              </div>
              <div className="bg-bg-card border-2 border-brandOrange rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center shadow-[0_0_25px_rgba(255,107,0,0.4)]" data-id="element-99" data-mp="235twdoif2rr8">
                <div className="font-display font-black text-[40px] md:text-[52px] text-brandOrange leading-none" data-id="element-100" data-mp="2d3q6cczmbgnr">
                  {minutes.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandOrange mt-1" data-id="element-101" data-mp="1khf1ur8w4vlo">
                  min
                </div>
              </div>
              <div className="font-display font-black text-[40px] md:text-[52px] py-2 text-brandOrange flex items-center" data-id="element-102" data-mp="1u78frywi9mt3">
                :
              </div>
              <div className="bg-bg-card border-2 border-brandOrange rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center shadow-[0_0_25px_rgba(255,107,0,0.4)]" data-id="element-103" data-mp="11pw1yta5xxnv">
                <div className="font-display font-black text-[40px] md:text-[52px] text-brandOrange leading-none" data-id="element-104" data-mp="38eej82bn02pn">
                  {seconds.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandOrange mt-1" data-id="element-105" data-mp="2zdgbb8y2vb1s">
                  seg
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 font-sans font-bold text-base md:text-xl text-gold leading-snug" data-id="element-106" data-mp="3r4w11buxldw8">
              <AlertTriangle size={20} data-id="element-107" data-mp="3w2fpf4lcf71w" />
              <span data-id="element-108" data-mp="3w1cxctcaayke">Después sube el precio. No vuelve.</span>
            </div>

            <div className="p-4 rounded-[14px] border border-line bg-bg-alt" data-id="element-109" data-mp="3i3of7t9lq5j1">
              <div className="flex justify-between font-sans text-[13px] md:text-[15px] leading-[1.5] text-txt-body mb-3" data-id="element-110" data-mp="3n1pstyo9dcn4">
                <span className="flex items-center gap-2" data-id="element-111" data-mp="26qvo8komxl41">
                  <span className="w-2 h-2 rounded-full bg-brandOrange animate-pulse" data-id="element-112" data-mp="2box5d02i3acv"></span>{' '}
                  Cupos al precio de lanzamiento
                </span>
                <span className="text-brandOrange font-bold" data-id="element-113" data-mp="2yclyee10yhph">Quedan pocos</span>
              </div>
              <div className="w-full bg-line rounded-full h-2 mb-2 overflow-hidden" data-id="element-114" data-mp="2td0xhy2anza4">
                <div className="bg-brandOrange h-full rounded-full" style={{
                width: '71%'
              }} data-id="element-115" data-mp="2tf3vp5dloypx"></div>
              </div>
              <p className="font-sans text-[12px] md:text-[13px] text-txt-muted text-right" data-id="element-116" data-mp="3m0wvd63lnx8h">
                71% de los cupos ya tomados
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const Pricing = () => {
  const includes = [{
    icon: '📚',
    label: '6 Tomos Completos',
    detail: '365 sesiones listas para dictar',
    price: '$49.990 ARS'
  }, {
    icon: '🎁',
    label: '5 Bonos Exclusivos',
    detail: 'Adaptaciones, warm-ups, cierres y scripts',
    price: '$50.000 ARS'
  }];
  return <Section className="bg-bg-alt !pt-6 !pb-8 md:!pt-12 md:!pb-14" id="pricing" data-id="element-117" data-mp="b7hojy9rme0m">
      <div className="max-w-lg mx-auto" data-id="element-118" data-mp="b9kpvegdbtkn">
        <FadeIn className="text-center mb-5 md:mb-7" data-id="element-119" data-mp="g61ee9rhc9y9">
          <p className="font-sans text-[12.5px] md:text-[15px] text-txt-body" data-id="element-120" data-mp="g8njm2qweddb">
            Estás a un paso de resolver todas tus clases...
          </p>
          <h2 className="font-display font-extrabold uppercase text-[32px] md:text-[44px] leading-[1.02] text-txt-primary mt-2 max-w-[15ch] md:max-w-none mx-auto" data-id="element-121" data-mp="q50jjid1dngi">
            OFERTA ESPECIAL DE{' '}
            <span className="text-brandOrange" data-id="element-122" data-mp="z4dllpytz9r7">LANZAMIENTO</span>
          </h2>
          <p className="font-sans text-[11.5px] md:text-[14px] leading-[1.45] text-txt-muted mt-1.5" data-id="element-123" data-mp="13vlven42ox4w">
            Tomos, bonos y 365 sesiones listas en un solo acceso.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-124" data-mp="1duuyc5gx1m3e">
          <div className="relative rounded-[20px] md:rounded-[24px] border-2 border-brandOrange bg-bg-card px-4 pt-7 pb-4 md:px-7 md:pt-9 md:pb-6 shadow-[0_0_60px_rgba(255,107,0,0.22),inset_0_0_30px_rgba(255,107,0,0.03)]" data-id="element-125" data-mp="1dvmi8j15hvdu">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brandOrange text-white font-sans font-bold uppercase tracking-[1.5px] text-[9.5px] md:text-[11px] px-3 py-1 rounded-full whitespace-nowrap shadow-[0_0_20px_rgba(255,107,0,0.5)]" data-id="element-126" data-mp="2hdv19jx2jhtl">
              ⭐ MÁS ELEGIDO
            </div>

            <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted text-center mb-3 md:mb-4" data-id="element-127" data-mp="2vd4j0o0xajzo">
              Lo que incluye tu MEGAPACK
            </p>

            <ul className="divide-y divide-line border-y border-line" data-id="element-128" data-mp="3584vtqe3oo8t">
              {includes.map(item => <li key={item.label} className="flex items-center justify-between gap-3 py-2.5 md:py-3" data-id="element-129" data-mp="3a1hg5obqy8vr">
                  <div className="flex items-start gap-2 min-w-0" data-id="element-130" data-mp="3eyzjmz6zvvwd">
                    <span className="text-[15px] md:text-lg leading-none mt-0.5" aria-hidden="true" data-id="element-131" data-mp="3j2fdxovldk5w">
                      {item.icon}
                    </span>
                    <div className="min-w-0" data-id="element-132" data-mp="1ccvi41dw8ahn">
                      <p className="font-sans font-bold text-[12.5px] md:text-[15px] text-txt-primary leading-snug" data-id="element-133" data-mp="1cdwx2gy15h4n">
                        {item.label}
                      </p>
                      <p className="font-sans text-[10.5px] md:text-[12.5px] leading-[1.35] text-txt-muted" data-id="element-134" data-mp="13dgsf45jw3y7">
                        {item.detail}
                      </p>
                    </div>
                  </div>
                  <span className="font-sans font-bold text-[12.5px] md:text-[15px] line-through text-danger shrink-0" data-id="element-135" data-mp="1v33gy7ak8es1">
                    {item.price}
                  </span>
                </li>)}
            </ul>

            <div className="pt-3 md:pt-4 text-center" data-id="element-136" data-mp="1m9gkeeyj37hs">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted" data-id="element-137" data-mp="1hczy7qaw337c">
                Precio original
              </p>
              <p className="font-display font-black text-[20px] md:text-[26px] leading-none line-through text-danger mt-1" data-id="element-138" data-mp="2a0vw2yc7315p">
                $99.990 ARS
              </p>
            </div>

            <div className="mt-3 md:mt-4 rounded-[16px] border border-brandOrange/30 bg-bg-alt px-4 py-3.5 md:py-5 text-center" data-id="element-139" data-mp="2szgvrr6e4tfj">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-brandOrange" data-id="element-140" data-mp="2k5carodxuc7x">
                Acceso completo hoy por
              </p>
              <p className="font-display font-black text-[46px] md:text-[64px] leading-none text-brandOrange mt-1" data-id="element-141" data-mp="2a6mqxq2hehp1">
                $19.990{' '}
                <span className="font-sans font-bold text-[14px] md:text-[18px] align-middle" data-id="element-142" data-mp="2f6iujo79o742">
                  ARS
                </span>
              </p>
              <p className="font-sans text-[10.5px] md:text-[13px] text-txt-muted mt-1.5" data-id="element-143" data-mp="257a3b33sd6le">
                Pago único · Sin suscripciones · Acceso inmediato
              </p>
            </div>

            <div className="mt-4 md:mt-5" data-id="element-144" data-mp="3g6py62ihdx5">
              <CTAButton href={PRODUCTS.megapack.checkoutUrl} fullWidth trackingProduct="megapack" onClick={markCheckoutStarted} className="!py-3.5 md:!py-4 !text-[14px] md:!text-base" data-id="element-145" data-mp="3f5c5tu42dbq">
                QUIERO EL MEGAPACK COMPLETO
              </CTAButton>
              <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 mt-2.5 md:mt-3.5 font-sans text-[10px] md:text-[12.5px] text-txt-muted" data-id="element-146" data-mp="1xo0ubaz6z9wv">
                <span data-id="element-147" data-mp="1svzljz18g1bl">🔒 Pago seguro</span>
                <span data-id="element-148" data-mp="27lyi5xd534oy">⚡ Acceso en minutos</span>
                <span data-id="element-149" data-mp="27knc1qw81kuo">🛡️ Garantía 7 días</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
};